import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Time, PlayerFlow, ChartArea, DocumentConversion } from '@carbon/pictograms-react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const ListBadges = makeShortcode("ListBadges");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const Caption = makeShortcode("Caption");
const ResourceCard = makeShortcode("ResourceCard");
const ExpressiveList = makeShortcode("ExpressiveList");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`I did my first coding on a `}<a parentName="p" {...{
          "href": "https://hackaday.com/2019/11/19/teardown-vtech-precomputer-1000-is-an-iconic-pc-in-a-toy-wrapper/"
        }}>{`PreComputer 1000`}</a>{` circa 1990, with a single-line LCD screen and a propensity to glitch and lose everything after I’d painstakingly typed in fifty lines or so of an ambitious program from the manual.`}</p>
      <p>{`Times have changed.`}</p>
    </PageDescription>
    <ListBadges frontmatter={props.pageContext.frontmatter} mdxType="ListBadges" />
    <p>{`For most of my career, my coding has either been private, personal projects in `}<strong parentName="p">{`Bash`}</strong>{` or `}<strong parentName="p">{`Perl`}</strong>{` or else custom `}<strong parentName="p">{`PHP`}</strong>{` and `}<strong parentName="p">{`Javascript`}</strong>{` on `}<a parentName="p" {...{
        "href": "/websites/"
      }}>{`websites`}</a>{` for clients. (Well, and also `}<a parentName="p" {...{
        "href": "/games"
      }}>{`games`}</a>{`.)`}</p>
    <p>{`But as I’ve learned `}<strong parentName="p">{`Python`}</strong>{` and `}<strong parentName="p">{`R`}</strong>{` for `}<a parentName="p" {...{
        "href": "/data-science/"
      }}>{`data science`}</a>{`, I’ve also learned modern coding practices like unit tests and coverage testing. My public `}<a parentName="p" {...{
        "href": "https://data.billalive.com"
      }}>{`Jupyter notebooks`}</a>{` include extensive code in Python and R, and I’ve released a fully funtional (and `}<a parentName="p" {...{
        "href": "https://yarm.readthedocs.io/"
      }}>{`documented!`}</a>{`) command-line tool written in Python: `}<a parentName="p" {...{
        "href": "https://yarm.readthedocs.io/"
      }}>{`yarm`}</a>{`.`}</p>
    <p>{`Now I’m preparing further private projects for public release, especially `}<a parentName="p" {...{
        "href": "#data-dashboards"
      }}>{`data dashboards`}</a>{` and tools for `}<a parentName="p" {...{
        "href": "#document-conversion"
      }}>{`document conversion.`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Yarm: Yet Another Report Maker</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Data Dashboards</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Document Conversion</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Languages I Love</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Linux Enthusiast</AnchorLink>
    </AnchorLinks>
    {/* ### YARM ### */}
    <h2>{`Yarm: Yet Another Report Maker`}</h2>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="https://yarm.readthedocs.io/" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB60lEQVQoz2OQkJGVkJGVkgWRkrJgBOZKyUK5UkhIUgahTEJGlkFCRlZcRpZPQlpCRlZQQlpYUkZIUoZbVJpHVIpfXFpQUoZHXJpbXJpfAoREpGUkZWX5JaVFpGQkZWQZxKVlZeXk/EzUxaRkXMzVLPSVbQ1Usrz1Mjz1vC3U7XRU0ux1shx0A03V/Y01NZQVBSRkfAzUTdWVhaVkGESkZZUV5D6X2fobqsxOMtpVbLYp2/Rhm+2XCY6HSiz2J5n9qHd4Xm1X6q5zNcf2Vq7NulDDf6UOmdaaXOLSDGLSsvJycpMCdRv8tO82W67JM07x0FhfZHSzw/JQtemFcvOmAG0BCWl5BdnLxWaPqyzvVVi+qrXKdtLgEpNmgAQAh6i0jYHSk8k2O+rMbs+1uTzF6sEcmxN9Ftf6rGoidBj5pZSV5J9Psy0M1NJQlX8wybo4SJtDWJpBSlZWUFImzl79Rqvlk6nW0S7qUwsN7y+3fbLKbmuH2Yl+i7JIHQ4haQlp2fUNJmkBmgzcknMLDXOCtTiFwDaLS8tqqMhrqSrIy8sJisuISctqqitoqCkoKsmpKMvLKciJy8iKSYOiSk5BTkwapF5WXk5cGhxVEjKyolIyIlIgbZAIFJUCITFpKAlRIw7WJgljQ+OZbAQApqiAAUEmrEUAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Yarm",
              "title": "Yarm",
              "src": "/static/0df721ce52fbe6491d8c6ca92d6a116b/3cbba/yarm_featured.png",
              "srcSet": ["/static/0df721ce52fbe6491d8c6ca92d6a116b/7fc1e/yarm_featured.png 288w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/a5df1/yarm_featured.png 576w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/3cbba/yarm_featured.png 1152w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/0b124/yarm_featured.png 1728w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/59ab2/yarm_featured.png 1800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
Yarm is available on <a href="https://pypi.org/project/yarm/">PyPI</a> and <a href="https://yarm.readthedocs.io/">fully documented</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="Yarm: Yet Another Report Maker" title="Create reports easily from SQL queries on spreadsheets and CSVs, and configure it all in YAML." href="https://yarm.readthedocs.io/" mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
            "alt": "Python"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
            "alt": "Pandas"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
            "alt": "NumPy"
          }}></img>
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`In Development`}</h2>
    <p>{`These began as personal projects for my own use, but I’m preparing to release them as open-source tools.`}</p>

    <h3>{`Data Dashboards`}</h3>
    {/* TODO When you finish these, also copy them to Data Science page. */}
    <div className="expressive-content-list-group">
      <ExpressiveList title="indiestats" titleType="expressive-02" background="true" pictogram={<ChartArea className="my-custom-class" mdxType="ChartArea" />} mdxType="ExpressiveList">
        <p>{`As an indie writer publishing my own books, I want to track ad campaigns and book sales in a single dashboard. Existing tools make this hard: your ads may be siloed in Facebook, while your sales data live in Amazon (and Barnes and Noble, and Kobo…) With indiestats, you see everything in one `}<a parentName="p" {...{
            "href": "https://shiny.rstudio.com/"
          }}>{`Shiny`}</a>{` web app written in R. Easy.`}</p>
        <div className="list-badges">
          <img {...{
            "src": "https://img.shields.io/badge/r-%23276DC3.svg?style=for-the-badge&logo=r&logoColor=white",
            "alt": "R"
          }}></img>
        </div>
      </ExpressiveList>
      <ExpressiveList title="orgclocksy 🦄 ⏲ 👀" titleType="expressive-02" background="true" pictogram={<Time className="my-custom-class" mdxType="Time" />} mdxType="ExpressiveList">
        <p>{`I’ve been tracking project times in `}<a parentName="p" {...{
            "href": "https://orgmode.org/"
          }}>{`Emacs Org mode`}</a>{` since about 2008. It’s about time for a dashboard that lets me explore all of this data, spread across hundreds of files. A `}<a parentName="p" {...{
            "href": "https://altair-viz.github.io/"
          }}>{`Vega-Altair`}</a>{` web app written in Python.`}</p>
        <div className="list-badges">
          <img {...{
            "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
            "alt": "Python"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
            "alt": "Pandas"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
            "alt": "NumPy"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/Matplotlib-%23ffffff.svg?style=for-the-badge&logo=Matplotlib&logoColor=black",
            "alt": "Matplotlib"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/orgmode-%2377AA99.svg?style=for-the-badge&logo=org&logoColor=white",
            "alt": "Org Mode"
          }}></img>
        </div>
  </ExpressiveList>
    </div>
    <h3>{`Document Conversion`}</h3>
    <div className="expressive-content-list-group">
      {/* TODO When you finish this, also add link to Fiction and Nonfiction pages. */}
      <ExpressiveList title="pandoc publishing workflow" titleType="expressive-02" background="true" pictogram={<DocumentConversion className="my-custom-class" mdxType="DocumentConversion" />} mdxType="ExpressiveList">
        <p>{`I write my `}<a parentName="p" {...{
            "href": "/fiction"
          }}>{`fiction`}</a>{` and `}<a parentName="p" {...{
            "href": "/nonfiction"
          }}>{`nonfiction`}</a>{` books in `}<a parentName="p" {...{
            "href": "https://orgmode.org/"
          }}>{`Emacs Org Mode,`}</a>{` then create the EPUBs and PDFs for publication using a custom toolchain of Makefiles, YAML configuration, and `}<a parentName="p" {...{
            "href": "https://pandoc.org/"
          }}>{`pandoc`}</a>{` to output Markdown and LaTeX. I tried to use Scrivener, but I found it scaled poorly. With this system, I can even include a bit of custom markup that I process with `}<inlineCode parentName="p">{`sed`}</inlineCode>{`… but I should probably rewrite this whole thing in Python before I release. 😉`}</p>
        <div className="list-badges">
          <img {...{
            "src": "https://img.shields.io/badge/Emacs-%237F5AB6.svg?&style=for-the-badge&logo=gnu-emacs&logoColor=white",
            "alt": "Emacs"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/shell_script-%23121011.svg?style=for-the-badge&logo=gnu-bash&logoColor=white",
            "alt": "Shell Script"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/latex-%23008080.svg?style=for-the-badge&logo=latex&logoColor=white",
            "alt": "LaTeX"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/markdown-%23000000.svg?style=for-the-badge&logo=markdown&logoColor=white",
            "alt": "Markdown"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/orgmode-%2377AA99.svg?style=for-the-badge&logo=org&logoColor=white",
            "alt": "Org Mode"
          }}></img>
        </div>
      </ExpressiveList>
      <ExpressiveList title="org2twee" titleType="expressive-02" background="true" pictogram={<PlayerFlow className="my-custom-class" mdxType="PlayerFlow" />} mdxType="ExpressiveList">
        <p>{`Have you noticed I `}<em parentName="p">{`really`}</em>{` like Org mode? When I discovered `}<a parentName="p" {...{
            "href": "http://twinery.org/"
          }}>{`Twine`}</a>{`, a tool for creating interactive fiction as simple web apps, I thought, why not just make each “room” a separate heading in Org mode? Thus `}<inlineCode parentName="p">{`org2twee`}</inlineCode>{`, a custom parser for `}<a parentName="p" {...{
            "href": "https://pandoc.org/"
          }}>{`pandoc`}</a>{` that lets me write in Org mode, then publish to an interactive Twine game. You can see the results in my Twine game, `}<a parentName="p" {...{
            "href": "https://vaccineshow.billalive.com"
          }}>{`The Vaccine Show!`}</a>{`, which leverages Org mode superpowers to not only manage the links between “rooms”, but also to run R code to generate charts based on spreadsheet data.`}</p>
        <div className="list-badges">
          <img {...{
            "src": "https://img.shields.io/badge/perl-%2339457E.svg?style=for-the-badge&logo=perl&logoColor=white",
            "alt": "Perl"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/docker-%230db7ed.svg?style=for-the-badge&logo=docker&logoColor=white",
            "alt": "Docker"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/orgmode-%2377AA99.svg?style=for-the-badge&logo=org&logoColor=white",
            "alt": "Org Mode"
          }}></img>
        </div>
      </ExpressiveList>
    </div>
    <h2>{`Languages and Tools I Love`}</h2>
    <p>{`I basically live in Emacs, the shell, and Firefox running `}<a parentName="p" {...{
        "href": "https://vimium.github.io/"
      }}>{`Vimium`}</a>{`.`}</p>
    <p>{`I’ve attempted to manage my entire file collection with Git (and `}<a parentName="p" {...{
        "href": "https://git-annex.branchable.com/"
      }}>{`git-annex`}</a>{`), but a monorepo didn’t exactly work out. I’m transitioning to Git repos for anything I type and `}<a parentName="p" {...{
        "href": "https://borgbackup.readthedocs.io/"
      }}>{`borg`}</a>{` for everything else.`}</p>
    <p>{`Perl was my first love, but Python won me over. Shell scripts and the UNIX stream do remain glorious, but these days I find I save time in the long run if I just start with Python.`}</p>
    <p>{`I’m flirting with Lisp… and not `}<em parentName="p">{`just`}</em>{` so I can level up Emacs without skinning my knuckles. Those Lispers promise a Total Paradigm Shift! But I really, really love how often Python Just Works.`}</p>
    <p>{`Oh, and I know just enough Haskell to tinker with my `}<a parentName="p" {...{
        "href": "https://xmonad.org/"
      }}>{`xmonad`}</a>{` config. Another tempting paradigm shift, but I’ll probably just do my functional programming in Python.`}</p>
    <p>{`When I first got serious about data science, I thought I’d be sticking to R. I learned R’s `}<inlineCode parentName="p">{`tidyverse`}</inlineCode>{` before Python’s `}<inlineCode parentName="p">{`pandas`}</inlineCode>{`, and I feared I would really miss the tidyverse `}<a parentName="p" {...{
        "href": "https://magrittr.tidyverse.org/reference/pipe.html"
      }}>{`pipe`}</a>{`. To my surprise, pandas has come to feel even more natural. Meanwhile, the Python module ecosystem feels orders of magnitude more diverse than what R has to offer. R does offer excellent tools for data analysis, but with Python, you get that plus `}<em parentName="p">{`everything else`}</em>{`.`}</p>
    <h2>{`Linux Enthusiast`}</h2>
    <p>{`With few interruptions, I’ve been running Linux as my main desktop since 2004. Getting that first Slackware install working was a fairly brutal coming-of-age ritual, but I’ve never looked back. For too long.`}</p>
    <p>{`Btw I use Arch… but only because a rolling release and the occasional AUR package turns out to be `}<em parentName="p">{`less`}</em>{` work, at least for me, than fighting with outdated packages in Ubuntu (or using snap).`}</p>
    <div className="list-badges">
      <img {...{
        "src": "https://img.shields.io/badge/Arch%20Linux-1793D1?logo=arch-linux&logoColor=fff&style=for-the-badge",
        "alt": "Arch"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Debian-D70A53?style=for-the-badge&logo=debian&logoColor=white",
        "alt": "Debian"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Ubuntu-E95420?style=for-the-badge&logo=ubuntu&logoColor=white",
        "alt": "Ubuntu"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/F_Droid-1976D2?style=for-the-badge&logo=f-droid&logoColor=white",
        "alt": "F Droid"
      }}></img>
    </div>
    <p>{`Next up: `}<a href="/web-dev/">{`Web Development`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      